"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _lazyVideo = _interopRequireDefault(require("../lazy-video"));
var _playButton = _interopRequireDefault(require("../../buttons/play-button"));
var _base = require("@site/pattern-library-utils/base.functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-v9p4dze"
});
const Video = /*#__PURE__*/(0, _react2.styled)(_lazyVideo.default)({
  name: "Video",
  class: "pl-v1bbt8t"
});
const Controls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Controls",
  class: "pl-c1c3nsk1"
});

/**
 * Marquee Inline Video Component.
 *
 * @param {Object} props React props
 * @param {String} props.introUrl Video URL
 * @param {String} props.introUrlWebm Video URL in WebM format
 * @param {String} props.introUrlLaptop Video URL for laptop
 * @param {String} props.introUrlLaptopWebm Video URL for laptop in WebM format
 * @param {String} props.thumbnailDesktop Thumbnail URL for desktop
 * @param {String} props.thumbnailMobile Thumbnail URL for mobile
 * @param {Element} props.videos React element with video props
 * @param {String} props.preload Preload setting for video
 * @param {Boolean} props.loop Loop setting for video
 * @param {Boolean} props.hidePlayButton Hide the play button controls
 * @returns {React.ReactElement} InlineVideo Component
 * @public
 */
function InlineVideo({
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  thumbnailDesktop,
  thumbnailMobile,
  videos = [],
  preload = 'auto',
  loop = true,
  hidePlayButton = false
}) {
  const [isPlaying, setIsPlaying] = (0, _react.useState)(false);
  const hasValidVideos = /*#__PURE__*/_react.default.isValidElement(videos);
  const storefrontVideoSource = (0, _react.useMemo)(() => {
    const extracted = (0, _base.extractBynderVideoSources)(videos, {
      thumbnailDesktop,
      thumbnailMobile
    });
    return extracted;
  }, [videos, thumbnailDesktop, thumbnailMobile]);
  const videoSource = (0, _react.useMemo)(() => ({
    fallback: thumbnailDesktop,
    laptop: introUrlLaptop,
    laptopWebm: introUrlLaptopWebm,
    fallbackMobile: thumbnailMobile,
    base: introUrl,
    baseWebm: introUrlWebm
  }), [thumbnailDesktop, introUrlLaptop, introUrlLaptopWebm, thumbnailMobile, introUrl, introUrlWebm]);
  const handleChange = () => setIsPlaying(prevCheck => !prevCheck);
  const handleVideoEnded = () => {
    if (!loop) {
      setIsPlaying(true);
    }
  };
  const finalVideoSource = hasValidVideos ? storefrontVideoSource : videoSource;
  return /*#__PURE__*/_react.default.createElement(VideoContainer, {
    className: "video-container"
  }, /*#__PURE__*/_react.default.createElement(Video, {
    videoSource: finalVideoSource,
    preload: preload,
    loop: loop,
    autoPlay: true,
    pause: isPlaying,
    onEnded: handleVideoEnded
  }), !hidePlayButton && /*#__PURE__*/_react.default.createElement(Controls, {
    "data-cy": "inline-video-control"
  }, /*#__PURE__*/_react.default.createElement(_playButton.default, {
    dataCy: "inline-video-play-button",
    handlePlay: handleChange,
    pause: !isPlaying,
    size: "small"
  })));
}
var _default = exports.default = InlineVideo;
InlineVideo.propTypes = {
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  introUrlLaptop: _propTypes.default.string,
  introUrlLaptopWebm: _propTypes.default.string,
  thumbnailDesktop: _propTypes.default.string,
  thumbnailMobile: _propTypes.default.string,
  videos: _propTypes.default.element,
  preload: _propTypes.default.string,
  loop: _propTypes.default.bool,
  hidePlayButton: _propTypes.default.bool
};